import {useI18n} from '@logistics-frontend/core/i18n'
import clsx from 'clsx'
import React from 'react'

import {classes} from './CommentButton.styles'

type Props = {
  feedback?: string
  onClick: VoidFunction
}

const CommentButton: React.FC<Props> = ({feedback, onClick}) => {
  const t = useI18n()

  return (
    <div className={classes.button} onClick={onClick}>
      <div className={clsx(classes.placeholder, feedback && classes.placeholderTop)}>{t('route_feedback')}</div>
      {feedback && <div>{feedback}</div>}
    </div>
  )
}

export default CommentButton
